var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleLeftSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angle-left-solid",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99982 14C6.7013 14 6.40263 13.8861 6.17513 13.6582L0.341798 7.82486C-0.113932 7.36914 -0.113932 6.63086 0.341798 6.17513L6.17513 0.34179C6.63086 -0.11393 7.36914 -0.11393 7.82487 0.34179C8.2806 0.79753 8.2806 1.53581 7.82487 1.99154L2.81623 7L7.8256 12.0094C8.28133 12.4651 8.28133 13.2034 7.8256 13.6591C7.59774 13.887 7.29878 14 6.99982 14Z",
    fill: "#AAAAAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeftSolid);
export default __webpack_public_path__ + "static/media/angleLeftSolid.c5e7c1584cb98723da8614574a8f6349.svg";
export { ForwardRef as ReactComponent };